import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import { NgxSpinnerService } from 'ngx-spinner';

import {
  FormModeEnum,
  ToolbarItem,
  TableActionParams,
  NotificationService,
  ModalService,
  BackendService,
  FieldStructure,
  TableSettings,
  CustomModalService,
  TableActionEnum,
  FilterSettings,
  FieldMapItem,
} from 'beyond-util';

import { SifarnikBase } from '../sifarnik-base/sifarnik-base';
import { BackendService as RtsBackendService } from '../../../services/backend.service';
import { EnumService } from '../../../services/enum.service';
import { FormCode } from '../../../enums/form-code.enum';
import { FormName } from '../../../enums/form-name.enum';
import { EndpointTypes } from '../../../enums/enpoint-types.enum';
import { ActionType } from '../../../enums/action-type.enum';

enum VrstaLica {
  Fizicko = 'fizicko',
  Pravno = 'pravno',
  Oglasivac = 'oglasivac',
}

enum VrstaPravnogLica {
  Domace = 'domace',
  Strano = 'strano',
}

@Component({
  selector: 'app-pregled-kupaca',
  templateUrl: './pregled-kupaca.component.html',
})
export class PregledKupacaComponent extends SifarnikBase
  implements OnInit, OnDestroy {
  VrstaLica = VrstaLica;
  VrstaPravnogLica = VrstaPravnogLica;
  private _subscriptions: Array<Subscription> = [];
  private _data: Array<any>;
  private _sapField: FieldMapItem;
  public showDetails = false;

  public validateSubject: Subject<any> = new Subject<any>();
  public validateSubject$ = this.validateSubject.asObservable();

  public refreshSAPLookup: Subject<any> = new Subject<any>();
  public refreshSAPLookup$ = this.refreshSAPLookup.asObservable();

  public fizickoLiceFieldStructure: FieldStructure;
  public pravnoLiceFieldStructure: FieldStructure;
  public oglasivacFieldStructure: FieldStructure;

  public settingsTableUgovoriDetails: TableSettings;
  public ugovoriList: Array<any> = [];

  public settingsTableKontaktPodaciDetails: TableSettings;
  public kontaktPodaciList: Array<any> = [];

  public SAPLookupSettings: TableSettings;
  public SAPLookupFilterSettings: FilterSettings;
  public SAPKlijentiList: any[];
  public SAPLookupListCount: number;
  private SAPPageOrderFilterPart: string;
  private SAPFilterQueryPart: string;

  vrstaLica: VrstaLica;
  vrstaPravnogLica: VrstaPravnogLica;

  domacePravnoLiceFieldStructure: FieldStructure;
  stranoPravnoLiceFieldStructure: FieldStructure;
  klijentFieldStructure: FieldStructure;

  actionType: ActionType;
  error: any;

  constructor(
    protected _backendService: BackendService,
    protected _modalService: ModalService,
    protected _customModalService: CustomModalService,
    protected _notificationService: NotificationService,
    private _rtsBackendService: RtsBackendService,
    private _enumService: EnumService,
    private _spinner: NgxSpinnerService
  ) {
    super(_backendService, _modalService, _notificationService);
  }

  ngOnInit() {
    setTimeout(() => {
      this._spinner.show();
      super.ngOnInit();
      this._enumService.fetchVrstaKlijenta();
    });
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  changeName() {
    if (typeof this.order === 'undefined') {
      return;
    }

    if (this.order.hasOwnProperty('naziv')) {
      this.name = this.order.naziv;
    } else if (this.mode === FormModeEnum.Add) {
      this.name = 'Novi klijent';
    } else if (this.order.hasOwnProperty('id')) {
      this.name = 'Klijenti';
    }
  }

  create() {
    this._spinner.show();
    const payload = { ...this.order };
    payload.VrstaKlijenta = this.getVrstaLicaValue();
    payload.KontaktPodaci = this.kontaktPodaciList;
    this._subscriptions.push(
      this._rtsBackendService
        .save(FormCode.MSKLI_KLI, FormName.PregledKlijenata, payload)
        .subscribe(data => {
          this.openServiceError(data);
          this.loadSettings();
        })
    );
  }

  update() {
    this._spinner.show();
    const payload = { ...this.order };
    payload.KontaktPodaci = this.kontaktPodaciList;
    this._subscriptions.push(
      this._rtsBackendService
        .update(FormCode.MSKLI_KLI, FormName.PregledKlijenata, payload)
        .subscribe(data => {
          this.openServiceError(data);
          this.loadSettings();
        })
    );
  }

  onTableActionFilter(event: any) {
    this._spinner.show();
    super.onTableActionFilter(event);
  }

  notifyError(message: string) {
    this._notificationService.notyError(message);
  }

  loadSettings() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSKLI_KLI,
          FormName.PregledKlijenata,
          EndpointTypes.AllEntities,
          this.filterQuery
        )
        .subscribe(data => {
          this._spinner.hide();

          if (!this.settingsTable) {
            this.disableInlineActions(data['Settings']);
            this.setSettings(data['Settings']);
            this.alterDetailsSettings(data.Settings.details[0]);
            this.settingsTableUgovoriDetails = new TableSettings(
              data.Settings.details[0],
              'table'
            );
          }

          this._data = data['ServiceData']['Data'];
          this._dataCount = data['ServiceData']['DataSumCount'];
          this.setAllFields();
          this.refreshTable();
        })
    );
  }

  alterDetailsSettings(settings) {
    settings.inlineAdding = false;
    settings.inlineEditing = false;
  }

  refreshTable() {
    this.setId(this._data);
    this.setRbr(this._data);
    this.orderListCount = this._dataCount;
    this.orderList = this._data;
  }

  addOrder() {
    this.setActionType(ActionType.Create);
    this.validateSubject.next();
  }

  updateOrder() {
    this.setActionType(ActionType.Update);
    this.validateSubject.next();
  }

  onDeleteConfirm() {
    this._spinner.show();
    this._subscriptions.push(
      this._rtsBackendService
        .delete(FormCode.MSKLI_KLI, FormName.PregledKlijenata, this.order.Id)
        .subscribe(() => {
          this._notificationService.openNoty('Uspešno brisanje');
          this.changeMode(FormModeEnum.Table);
          this.loadSettings();
        })
    );
  }

  onTableActionUpdate(event: TableActionParams) {
    super.onTableActionUpdate(event);
    this.refreshTable();
  }

  onTableActionView() {
    this.fetchAllSettings();
    this.setToolbarOptions({
      items: [ToolbarItem.ItemEdit(true, !this.order.status)],
    });

    this.fetchSingleEntity();
    this.changeMode(FormModeEnum.View);
    this.setInfobar(true, 'Marina Milenkovic', 1558801076316);
  }

  onTableActionAdd() {
    this._spinner.show();
    this.order = {};
    this.fetchAllSettings();
    this.showDetails = true;
    this.changeMode(FormModeEnum.Add);
  }

  panelInvisible(data) {
    data['Settings']['formSettings']['header'][0]['panels'][0][
      'panelVisible'
    ] = false;
  }

  fetchDomacePravnoLiceSettings() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSKLI_DPL,
          FormName.PregledKlijenata,
          EndpointTypes.ModelData,
          '',
          this.order.Id ? this.order.Id : null
        )
        .subscribe(data => {
          this._spinner.hide();
          this.panelInvisible(data);
          this.splitDetails(data.Settings, 8);
          this.domacePravnoLiceFieldStructure = new FieldStructure(
            data.Settings,
            'header'
          );
          this.setKontaktPodaci(data);
          this.setDomaceLiceSettings();
        })
    );
  }

  setStranoLiceSettings() {
    this.vrstaLica = VrstaLica.Pravno;
    this.vrstaPravnogLica = VrstaPravnogLica.Strano;

    this.klijentFieldStructure = this.stranoPravnoLiceFieldStructure;

    this.setToolbarOptions({
      items: [
        ToolbarItem.PreuzmiIzSapa(),
        ToolbarItem.ItemSave(true, !this.order.status),
      ],
    });
  }

  setDomaceLiceSettings() {
    this.vrstaLica = VrstaLica.Pravno;
    this.vrstaPravnogLica = VrstaPravnogLica.Domace;
    this.klijentFieldStructure = this.domacePravnoLiceFieldStructure;

    this.setToolbarOptions({
      items: [
        ToolbarItem.PreuzmiIzSapa(),
        ToolbarItem.ItemSave(true, !this.order.status),
      ],
    });
  }

  setFizickoLiceSettings() {
    this.vrstaLica = VrstaLica.Fizicko;
    this.klijentFieldStructure = this.fizickoLiceFieldStructure;

    this.setToolbarOptions({
      items: [
        ToolbarItem.PreuzmiIzSapa(),
        ToolbarItem.ItemSave(true, !this.order.status),
      ],
    });
  }

  setOglasivacSettings() {
    this.vrstaLica = VrstaLica.Oglasivac;

    this.klijentFieldStructure = this.oglasivacFieldStructure;

    this.setToolbarOptions({
      items: [ToolbarItem.ItemSave(true, !this.order.status)],
    });
  }

  fetchStranoPravnoLiceSettings() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSKLI_SPL,
          FormName.PregledKlijenata,
          EndpointTypes.ModelData,
          '',
          this.order.Id ? this.order.Id : null
        )
        .subscribe(data => {
          this.panelInvisible(data);
          this.splitDetails(data.Settings, 8);
          this.stranoPravnoLiceFieldStructure = new FieldStructure(
            data.Settings,
            'header'
          );
          this.setDomaceLiceSettings();
          this.setKontaktPodaci(data);
        })
    );
  }

  fetchFizickoLiceSettings() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSKLI_FL,
          FormName.PregledKlijenata,
          EndpointTypes.ModelData,
          '',
          this.order.Id ? this.order.Id : null
        )
        .subscribe(data => {
          this.panelInvisible(data);
          this.splitDetails(data.Settings, 8);
          this.fizickoLiceFieldStructure = new FieldStructure(
            data.Settings,
            'header'
          );

          this.setKontaktPodaci(data);
        })
    );
  }

  fetchOglasivacSettings() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSKLI_OGS,
          FormName.PregledKlijenata,
          EndpointTypes.ModelData,
          '',
          this.order.Id ? this.order.Id : null
        )
        .subscribe(data => {
          // this.removeField(data.Settings, 'SAPBroj');

          this.panelInvisible(data);
          this.splitDetails(data.Settings, 8);

          this.oglasivacFieldStructure = new FieldStructure(
            data.Settings,
            'header'
          );

          this.setKontaktPodaci(data);
        })
    );
  }

  fetchSingleEntity() {
    this._spinner.show();

    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          this.getFormCode(),
          FormName.PregledKlijenata,
          EndpointTypes.SingleEntity,
          '',
          this.order.Id ? this.order.Id : null
        )
        .subscribe(data => {
          this._spinner.hide();
          this.order = data.ServiceData[0];

          this.panelInvisible(data);
          this.splitDetails(data.Settings, 8);

          this.showDetails = true;
          this.klijentFieldStructure = new FieldStructure(
            data.Settings,
            'header'
          );

          this.ugovoriList = data['ServiceData'][0].Ugovori;
          this.setKontaktPodaci(data);
          this.order.KontaktPodaci = { ...this.kontaktPodaciList };
          if (this.order.Id) {
            this.onViewModeWithParams(
              data.Privilegije.includes('MSKLI_KLI_CREATE'),
              data.Privilegije.includes('MSKLI_KLI_DELETE'),
              data.Privilegije.includes('MSKLI_KLI_UPDATE')
            );
          }
        })
    );
  }

  mapKontaktPodaci(kontaktPodaci) {
    kontaktPodaci.forEach(kp => {
      (kp.rbr = kp.Id), (kp.id = kp.id);
    });

    return kontaktPodaci;
  }

  setKontaktPodaci(data) {
    this.settingsTableKontaktPodaciDetails = new TableSettings(
      data.Settings.details[0],
      'table'
    );

    if (data['ServiceData']) {
      const kpodaci = data['ServiceData'][0].KontaktPodaci;
      this.kontaktPodaciList = this.mapKontaktPodaci(kpodaci);
    } else {
      this.kontaktPodaciList = [];
    }
  }

  resetFieldStructures() {
    this.klijentFieldStructure = null;
    this.ugovoriList = [];
    this.showDetails = false;
  }

  getFormCode() {
    if (this.order.VrstaKlijenta === 3) {
      return FormCode.MSKLI_OGS;
    } else if (this.order.VrstaKlijenta === 2) {
      return FormCode.MSKLI_FL;
    } else if (this.order.VrstaKlijenta === 1) {
      return FormCode.MSKLI_SPL;
    } else if (this.order.VrstaKlijenta === 0) {
      return FormCode.MSKLI_DPL;
    }
  }

  getVrstaLicaValue() {
    switch (this.vrstaLica) {
      case VrstaLica.Pravno:
        switch (this.vrstaPravnogLica) {
          case VrstaPravnogLica.Domace:
            return 'DomacePravnoLice';
          case VrstaPravnogLica.Strano:
            return 'StranoPravnoLice';
        }
        break;
      case VrstaLica.Fizicko:
        return 'FizickoLice';
      case VrstaLica.Oglasivac:
        return 'Oglasivac';
    }
  }

  onEditMode() {
    this._orderBeforeEditing = { ...this.order };

    if (this.vrstaLica !== this.VrstaLica.Oglasivac) {
      this.setToolbarOptions({
        items: [
          ToolbarItem.PreuzmiIzSapa(),
          ToolbarItem.ItemSave(),
          ToolbarItem.ItemCancel(),
        ],
      });
    } else {
      this.setToolbarOptions({
        items: [ToolbarItem.ItemSave(), ToolbarItem.ItemCancel()],
      });
    }
  }

  fetchAllSettings() {
    this.resetFieldStructures();
    this.fetchFizickoLiceSettings();
    this.fetchDomacePravnoLiceSettings();
    this.fetchStranoPravnoLiceSettings();
    this.fetchOglasivacSettings();
    this.fetchSAPLookupSettings();
  }

  onCancel() {
    this.resetFieldStructures();
    this.order.Id = this._orderBeforeEditing.Id;
    this.fetchSingleEntity();
    this.changeMode(FormModeEnum.View);
  }

  mergeDataFromSAP(sapKlijent, id) {
    const klijent = this.mapToSmartsKlijent(sapKlijent);
    for (const key in klijent) {
      if (this.order.hasOwnProperty(key)) {
        this.order[key] = klijent[key];
      }
    }

    this.order.Id = id;
  }

  mapToSmartsKlijent(sapKlijent) {
    const klijent: any = {};

    if (sapKlijent != null) {
      klijent.SAPBroj = sapKlijent.SAPBroj;
      klijent.Adresa = `${sapKlijent.Adresa}, ${sapKlijent.Drzava}`;
      klijent.BrojTelefona = sapKlijent.Telefon;
      klijent.Faks = sapKlijent.Faks;

      switch (this.vrstaLica) {
        case VrstaLica.Fizicko:
          klijent.JMBG = sapKlijent.PibJmbgVat;
          klijent.PrezimeIme = sapKlijent.Naziv;
          break;

        case VrstaLica.Pravno:
          switch (this.vrstaPravnogLica) {
            case VrstaPravnogLica.Domace:
              klijent.PIB = sapKlijent.PibJmbgVat;
              klijent.MaticniBroj = sapKlijent.MaticniBroj;
              klijent.Naziv = sapKlijent.Naziv;
              break;

            case VrstaPravnogLica.Strano:
              klijent.VAT = sapKlijent.PibJmbgVat;
              klijent.Naziv = sapKlijent.Naziv;
              break;
          }
          break;

        case 'oglasivac':
          klijent.Naziv = sapKlijent.Naziv;
          break;
      }
    }

    return klijent;
  }

  fetchSAPLookupSettings() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSKLI_SAP2,
          FormName.PregledKlijenata,
          EndpointTypes.AllEntities,
          ``
        )
        .subscribe(data => {
          this.setLookupActions(data.Settings);
          this.SAPLookupSettings = new TableSettings(data.Settings, 'table');
          this.SAPLookupFilterSettings = new FilterSettings(data.Settings);
          this.setAllFields(this.SAPLookupFilterSettings);
        })
    );
  }

  onPreuzmiIzSAPa() {
    this.SAPKlijentiList = [];
    this._customModalService.open('custom-modal');
    this.setSAPOrderPagingFilter();
    this.refreshSAPLookup.next();
  }

  fillSAPLookup(data: any) {
    this.SAPLookupListCount = data.ServiceData.DataSumCount;
    this.setId(data.ServiceData.Data);
    this.SAPKlijentiList = data.ServiceData.Data;
  }

  private setLookupActions(settings: any) {
    settings.inlineAdding = false;
    settings.inlineEditing = false;
    settings.additable = false;
    settings.editable = false;
    settings.deletable = false;
  }

  setSAPOrderPagingFilter(filter?) {
    if (!filter) {
      this.SAPPageOrderFilterPart = '?pageNumber=1&pageSize=10';

      return;
    }
    this.SAPPageOrderFilterPart = `?pageNumber=${filter.pageCurrent}&pageSize=${
      filter.rowsOnPage
    }&order=${
      filter.sortOrder ? filter.sortOrder.fieldName : null
    }&orderDirection=${filter.direction}`;
  }

  setSAPSearchFilter(filter) {
    this.SAPFilterQueryPart = '';
    filter.filterObjects.forEach(fo => {
      this.SAPFilterQueryPart += `&${fo.name}=${fo.value}`;
    });
  }

  onSAPLookupTableAction(event) {
    switch (event.action) {
      case TableActionEnum.Select:
        if (event.document) {
          this.fillSAPData(event.document);
          this._customModalService.close('custom-modal');
        }
        break;
      case TableActionEnum.Filter:
        this.setSAPOrderPagingFilter(event.filter);
        this.fetchSAPKlijenti();
        break;
      default:
        break;
    }
  }

  fillSAPData(sapklijent: any) {
    if (this.mode === FormModeEnum.Add) {
      this.order = this.mapToSmartsKlijent(sapklijent);
    } else if (this.mode === FormModeEnum.Edit) {
      this._modalService.openModal(
        'Postojeći podaci o klijentu biće zamenjeni podacima iz SAP-a. Da li želite da nastavite?',
        response => {
          if (response) {
            this.mergeDataFromSAP(sapklijent, this.order.Id);
          }
        }
      );
    }
  }

  onSAPLookupFilterAction(event) {
    this.setSAPSearchFilter(event.filter);
    this.fetchSAPKlijenti();
  }

  fetchSAPKlijenti() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSKLI_SAP2,
          FormName.PregledKlijenata,
          EndpointTypes.AllEntities,
          this.SAPPageOrderFilterPart + this.SAPFilterQueryPart
        )
        .subscribe(data => {
          if (data.Error) {
            this.notifyError(data.Error.ErrorMessage);
          } else {
            if (data.ServiceData) {
              this.fillSAPLookup(data);
            } else {
              this._notificationService.openNoty(
                'Nisu pronađeni podaci po zadatom filteru.'
              );
            }
          }
        })
    );
  }

  cancelSAPLookup(modalName: string) {
    this._customModalService.close(modalName);
  }

  onClose() {
    super.onClose();
    this.resetFieldStructures();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/pregled-kupaca/pregled-kupaca.component.ts